<footer class="footer" *transloco="let t; prefix: 'footer'">
  <div class="footer__inner">
    <img src="assets/images/htx-logo.png" alt="HealthTrack-X" class="footer__logo">

    <nav class="footer__links" aria-label="Footer-Navigation">
      <a routerLink="/glossary" class="footer__link">{{ t('glossary') }}</a>
      <a routerLink="/terms" class="footer__link">{{ t('terms') }}</a>
      <a routerLink="/privacy-policy" class="footer__link">{{ t('privacyPolicy') }}</a>
      <a routerLink="/imprint" class="footer__link">{{ t('imprint') }}</a>
    </nav>

    <span class="footer__copy">© {{ currentYear }} HealthTrack-X</span>
  </div>
</footer>
